export const leadDeliveryKeys = {
  all: ["autoleads", "lead-delivery"] as const,
  list: () => [...leadDeliveryKeys.all, "list"] as const,
  preview: (campaignId: number) =>
    [...leadDeliveryKeys.all, "preview", campaignId] as const,
  hubspotStatusAll: () => [...leadDeliveryKeys.all, "hubspot-status"] as const,
  hubspotStatus: (campaignId: number) =>
    [...leadDeliveryKeys.all, "hubspot-status", campaignId] as const,
  syncProgress: (campaignId: number) =>
    [...leadDeliveryKeys.all, "sync-progress", campaignId] as const,
}
